import { Module } from '../Module';
import { UserSettings } from '../resources/UserSettings';
import { IResult } from '../ServerApi/types/IResponse';
import { UpdateUserEmailNotification } from '../services/UserSettingsNotification';

// methods exposed outside the directive
export interface IEditEmailControls {
  isBusy: () => boolean;
  isDirty: () => boolean;
  isValid: () => boolean;
  submit: (userId: string, username: string) => ng.IPromise<any>;
}

export interface IEditEmailScope extends ng.IScope {
  busy: boolean;
  controls: IEditEmailControls;
  email: string;
  emailForm: ng.IFormController;
  originalEmail: string;
  delayUpdateEmailRequest: boolean;
}

Module.instance().directive('tbEditEmail', [
  'UpdateUserEmailNotification',
  'UserSettings',
  (updateUserEmailNotification: UpdateUserEmailNotification,
   userSettings: UserSettings) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'editEmail.html',
      scope: {
        email: '@',
        controls: '=?',
        delayUpdateEmailRequest: '@'
      },
      link: (scope: IEditEmailScope) => {

        scope.busy = false;

        // save original displayName
        scope.originalEmail = scope.email;

        scope.controls = {
          // make backend request to update the display name
          submit: (userId: string, username: string) => {
            scope.busy = true;
            const email = scope.email;
            //In certain scenarios, updating a user's email requires updating their username as well
            //This requires waiting for an index update, so the request should be delayed
            if(scope.delayUpdateEmailRequest) {
              return userSettings.updateUserEmailAndDelay(userId, email)
                .then((result: IResult) => {
                  // toasts
                  updateUserEmailNotification.notify(result, username, email);
                  scope.busy = false;
                  return email;
              });
            }
            return userSettings.updateUserEmail(userId, email)
              .then((result: IResult) => {
                // toasts
                updateUserEmailNotification.notify(result, username, email);
                scope.busy = false;
                return email;
              });
          },
          isBusy: () => {
            return scope.busy;
          },
          // checks whether the field has been changed
          isDirty: () => {
            return scope.email !== scope.originalEmail;
          },
          // checks whether the input is valid
          isValid: () => {
            return !scope.emailForm.$invalid;
          }
        };
      }
    };
  }
]);
